import { ListItem } from '../list-item/list-item';

export type SupportedAgeGroupItem = {
  ageGroup: AgeGroupEnum;
  order: number;
} & ListItem;

export type SupportedAgeGroup = {
  id: string;
  supportedAgeGroups: SupportedAgeGroupItem[];
};

export type UserSupportedAgeGroup = {
  userId: string;
  id: string;
  supportedAgeGroupId: string;
  name: string;
  ageGroup: AgeGroupEnum;
  order: number;
};

export const enum AgeGroupEnum {
  children_or_teens = 'children_or_teens',
  young_adults = 'young_adults',
  adults = 'adults',
  elderly = 'elderly'
}
